import { Reveal, Kicker } from "./Reveal";

const REASONS = [
  "High decision frequency",
  "Directly measurable financial outcomes",
  "Significant governance risk",
  "An existing executive buyer",
  "A path into adjacent commercial decisions",
];

export default function Thesis() {
  return (
    <section id="investors" className="border-b border-white/10" data-testid="thesis-section">
      <div className="mx-auto max-w-[1600px] px-6 py-28 lg:px-12 lg:py-40">
        <Reveal>
          <Kicker index="10" label="Why this can become infrastructure" />
          <h2 className="max-w-5xl font-display text-4xl font-extrabold leading-[1.02] tracking-tighter sm:text-5xl lg:text-6xl" data-testid="thesis-heading">
            AI capability is becoming cheaper.{" "}
            <span className="text-[#00FF41]">Commercial delegation becomes the scarce layer.</span>
          </h2>
        </Reveal>

        <div className="mt-16 grid gap-16 lg:grid-cols-12">
          <Reveal className="lg:col-span-7">
            <div className="space-y-6 font-mono text-sm leading-relaxed text-zinc-400">
              <p>
                Recommendation quality alone is unlikely to remain a durable moat. Pricing applications,
                enterprise platforms and frontier-model providers will increasingly generate credible
                commercial actions.
              </p>
              <p className="text-zinc-300">The unresolved problem is the institutional handover of authority.</p>
              <p>
                Axiosera is designed to own that moment: what may the machine decide, under which policy,
                with what level of autonomy, how is it executed, and what evidence proves what happened?
              </p>
            </div>
          </Reveal>
          <Reveal delay={0.15} className="lg:col-span-5">
            <div className="border border-white/10 bg-[#0F0F11] p-8">
              <div className="font-mono text-[11px] uppercase tracking-[0.25em] text-zinc-500">Pricing is the first decision family because it provides</div>
              <div className="mt-6 space-y-0">
                {REASONS.map((r, i) => (
                  <div key={r} className="flex items-baseline gap-4 border-b border-white/5 py-4 last:border-b-0" data-testid={`thesis-reason-${i + 1}`}>
                    <span className="font-mono text-xs text-[#00FF41]">0{i + 1}</span>
                    <span className="font-mono text-xs leading-relaxed text-zinc-300">{r}</span>
                  </div>
                ))}
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
